/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Work Plan View Detail Level
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type WorkPlanViewDetailLevelEnum = 'All Rows' | 'Strategy' | 'Activity' | 'Task';

export const WorkPlanViewDetailLevelEnum = {
    AllRows: 'All Rows' as WorkPlanViewDetailLevelEnum,
    Strategy: 'Strategy' as WorkPlanViewDetailLevelEnum,
    Activity: 'Activity' as WorkPlanViewDetailLevelEnum,
    Task: 'Task' as WorkPlanViewDetailLevelEnum
};

marker('All Rows');
marker('Strategy');
marker('Activity');
marker('Task');

